(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }}).catch((e) => {
              console.error(e);
            });
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-bundle"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  class TeveoProductReviews extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mode !== 'full') return;

      this.items = Array.from(this.querySelectorAll('[data-review-item]'));
      this.list = this.querySelector('[data-review-list]');
      this.ratingFilter = this.querySelector('[data-review-rating-filter]');
      this.sort = this.querySelector('[data-review-sort]');
      this.search = this.querySelector('[data-review-search]');
      this.pagination = this.querySelector('[data-review-pagination]');
      this.empty = this.querySelector('[data-review-empty]');
      this.perPage = Number(this.dataset.perPage) || 4;
      this.currentPage = 1;

      this.ratingFilter?.addEventListener('change', () => {
        this.currentPage = 1;
        this.render();
      });
      this.sort?.addEventListener('change', () => {
        this.currentPage = 1;
        this.render();
      });
      this.search?.addEventListener('input', () => {
        this.currentPage = 1;
        this.render();
      });

      this.renderRelativeTimes();
      this.render();
    }

    render() {
      const term = this.search?.value.trim().toLocaleLowerCase() || '';
      const ratingFilter = this.ratingFilter?.value || 'all';
      const sort = this.sort?.value || this.dataset.defaultSort || 'highest_rating';
      const matches = this.items.filter((item) => {
        const matchesTerm = !term || item.dataset.search.includes(term);
        const matchesRating = ratingFilter === 'all' || Number(item.dataset.rating) === Number(ratingFilter);
        return matchesTerm && matchesRating;
      });

      matches.sort((left, right) => this.compare(left, right, sort));
      this.list.append(...matches);

      const pages = Math.max(1, Math.ceil(matches.length / this.perPage));
      this.currentPage = Math.min(this.currentPage, pages);
      const start = (this.currentPage - 1) * this.perPage;
      const visible = new Set(matches.slice(start, start + this.perPage));

      this.items.forEach((item) => {
        item.hidden = !visible.has(item);
      });
      this.empty.hidden = matches.length !== 0;
      this.renderPagination(pages, matches.length);
    }

    compare(left, right, sort) {
      const number = (item, key) => Number(item.dataset[key]) || 0;
      const localePriority = number(right, 'localePriority') - number(left, 'localePriority');
      if (localePriority) return localePriority;
      if (sort === 'date_asc') return number(left, 'date') - number(right, 'date');
      if (sort === 'highest_rating') return number(right, 'rating') - number(left, 'rating') || number(right, 'date') - number(left, 'date');
      if (sort === 'lowest_rating') return number(left, 'rating') - number(right, 'rating') || number(right, 'date') - number(left, 'date');
      if (sort === 'helpful_desc') return number(right, 'helpful') - number(left, 'helpful') || number(right, 'date') - number(left, 'date');
      return number(right, 'date') - number(left, 'date');
    }

    renderPagination(pages, resultCount) {
      this.pagination.replaceChildren();
      this.pagination.hidden = resultCount === 0 || pages <= 1;
      if (this.pagination.hidden) return;

      this.pagination.append(this.pageButton(this.dataset.previousLabel, this.currentPage - 1, this.currentPage === 1));
      const visiblePages = this.pageWindow(pages);
      visiblePages.forEach((page) => {
        if (page === 'ellipsis') {
          const ellipsis = document.createElement('span');
          ellipsis.textContent = '…';
          ellipsis.setAttribute('aria-hidden', 'true');
          this.pagination.append(ellipsis);
          return;
        }
        this.pagination.append(this.pageButton(String(page), page, false, page === this.currentPage));
      });
      this.pagination.append(this.pageButton(this.dataset.nextLabel, this.currentPage + 1, this.currentPage === pages));
    }

    pageWindow(pages) {
      if (pages <= 9) return Array.from({ length: pages }, (_, index) => index + 1);
      const values = new Set([1, pages, this.currentPage - 1, this.currentPage, this.currentPage + 1]);
      const sorted = Array.from(values).filter((page) => page >= 1 && page <= pages).sort((a, b) => a - b);
      const result = [];
      sorted.forEach((page, index) => {
        if (index > 0 && page - sorted[index - 1] > 1) result.push('ellipsis');
        result.push(page);
      });
      return result;
    }

    pageButton(label, page, disabled, current = false) {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = label;
      button.disabled = disabled;
      if (current) button.setAttribute('aria-current', 'page');
      if (!Number.isNaN(Number(label))) button.setAttribute('aria-label', `${this.dataset.pageLabel} ${label}`);
      button.addEventListener('click', () => {
        this.currentPage = page;
        this.render();
        this.querySelector('[data-review-list]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      return button;
    }

    renderRelativeTimes() {
      const formatter = new Intl.RelativeTimeFormat(document.documentElement.lang || undefined, { numeric: 'auto' });
      const now = Date.now();

      this.querySelectorAll('[data-review-time]').forEach((time) => {
        const timestamp = Number(time.dataset.dateEpoch);
        if (!timestamp) return;
        const days = Math.round((timestamp - now) / 86400000);
        const unit = Math.abs(days) < 1 ? 'hour' : 'day';
        const value = unit === 'hour' ? Math.round((timestamp - now) / 3600000) : days;
        time.title = time.textContent.trim();
        time.textContent = formatter.format(value, unit);
      });
    }
  }

  if (!customElements.get('teveo-product-reviews')) {
    customElements.define('teveo-product-reviews', TeveoProductReviews);
  }

  } catch(e) { console.error(e); }
})();
})();
